import { ThankYou } from "components/ThankYou/ThankYou";
import { observer } from "mobx-react";
import { Store } from "state/store";
import { THANK_YOU_SCREEN_TITLE } from "./Title.const";
export type ThankYouScreenProps = { store: Store };
const ThankYouScreen = ({ store }: ThankYouScreenProps) => {
  document.title = THANK_YOU_SCREEN_TITLE;
  return (
    <>
      <ThankYou fetching={store.fetching} error={store.error} />
    </>
  );
};
const ThankYouScreenObserver = observer(ThankYouScreen);
export { ThankYouScreenObserver as ThankYouScreen };
